import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepMandatoryN = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		transform: "translate(-3 -3)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 8,
				cy: 8,
				r: 4,
				fill: "#4A5666",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				strokeWidth: 1.5,
				d: "m11.5 11.5 7.071 7.071"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				strokeWidth: 2,
				d: "M19.56 19.56 16.38 18.5l2.121-2.121z"
			})
		]
	})
});
export default SvgDepMandatoryN;
